






















import { Component, Prop, Vue } from 'vue-property-decorator';
import LocationsTab from '@/components/LocationsTab.vue';
import { HOST } from '@/global';

@Component({
  name: 'LocationsDetails',
  components: {}
})
export default class LocationsDetails extends Vue {
  @Prop() compData: any;
  @Prop() isOpen!: boolean;
  HOST: string = HOST;

  open() {
    this.$emit('open');
  }
}
